import { HStack, Text } from '@rbilabs/universal-components';

export const ProductPriceCaloriesContainer = HStack.withConfig({
  width: 'full',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: 0,
  marginBottom: 3,
  space: '$2',
});

export const ProductPriceCaloriesText = Text.withConfig(() => ({
  fontSize: {
    base: 'lg',
    md: '2xl',
  },
  numberOfLines: 1,
  adjustsFontSizeToFit: true,
}));
